
import React from "react";
import { Services } from "@/components/Services";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const ServicesPage = () => {
  return (
    <div className="min-h-screen" dir="rtl">
      <Navbar />
      <div className="pt-16 md:pt-0">
        <Services />
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;
